import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FullPageLoader } from 'src/components';
import { getValue, urlQueryParams } from 'src/helpers/custom-url-search-param';
import { CacheContext } from './cache-context';

export interface IQueryConfigContext {
  queryConfig: Object;
}

/* Provides an ICacheStore instance to children. */
export const QueryConfigContext = createContext<IQueryConfigContext>({ queryConfig: {} });

export function QueryConfigContextProvider(props: { cacheKey: string; children }) {
  const cacheStore = useContext(CacheContext);
  const [queryConfigReady, setQueryConfigReady] = useState(false);
  const [queryConfig, setQueryConfig] = useState<Object>({});
  const { search } = useLocation();

  useEffect(() => {
    const cachedParams = cacheStore.get(props.cacheKey);
    if (!cachedParams) {
      const params = getQueryParamsFromQueryString(search);
      cacheStore.set(props.cacheKey, params);
      setQueryConfig(params);
    }
    setQueryConfigReady(true);
  }, [search]);

  const getQueryParamsFromQueryString = (queryString: string): Object => {
    const entries = urlQueryParams(queryString);
    let queryParams = {};
    Object.keys(entries).forEach((key) => (queryParams[key] = getValue(entries, key)));
    return queryParams;
  };
  return queryConfigReady ? (
    <QueryConfigContext.Provider value={{ queryConfig }}>
      {props.children}
    </QueryConfigContext.Provider>
  ) : (
    <FullPageLoader showLoader={true} />
  );
}
